var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.$style.header, _vm.invisible ? 'is-invisible' : ''],attrs:{"data-print-hidden":""}},[_vm._t("toolbar")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }